import Vue from 'vue'
import VueResource from 'vue-resource';
import App from './App.vue'

import {getAuthorization} from './api';
import {store} from './store/store';

Vue.use(VueResource);
Vue.http.headers.common['Authorization'] = getAuthorization();
new Vue({
    el: '#asdoria_collection_app',
    store,
    render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js